export default __webpack_public_path__ + "static/media/thinkport-no-text.d809f5aa.svg";